/**
 * @Author     : Fanng(fanng@live.com)
 * @CreateTime : 03/06/2017 5:47 PM
 */

export default function install(Vue)
{

    /**
     * 路由访问权限验证
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    Vue.prototype._authenticate = function (to, from, next)
    {
        var alias = typeof to.meta.alias != 'undefined' ? to.meta.alias : to.name;

        if (_.indexOf (window.App.module_accessible_alias, alias) > 0)
        {
            return next ()
        }
        else
        {
            return next ('/no_privileged')
        }
    }

    /**
     * toString
     *
     * @param v
     * @returns {*}
     * @private
     */
    Vue.prototype._toString = function(v)
    {
        return v.toString();
    }

    /**
     * @param v
     */
    Vue.prototype.wan = function(v){
        const num = parseInt(v)
        const num2 = num / 10000
        if (num2 >= 1) {
            return Math.round(num2 * 100) / 100 + '万'
        } else {
            return num
        }
       // return  Math.round((wan /10000) * 100) / 100+'万'
    }

    /**
     * 获取class对象
     *
     * @param className
     * @returns {Array}
     */
    Vue.prototype.getElementsByClassName = function (className) {
        var all = document.all ? document.all : document.getElementsByTagName( ' *' );
        var elements = [];
        for ( var e = 0; e < all.length; e ++ ) {
            if (all[e].className == className) {
                elements[elements.length] = all[e];
            }
        }
        return elements;
    }

    /**
     * dashboard icon badge 计数
     *
     * @param v
     * @returns {number}
     */
    Vue.prototype.iconBadgeCount = function(v)
    {
        return v>999?999:v;
    }

    /**
     * 需要权限验证
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    Vue.prototype._requireAuth = function (to, from, next)
    {
        if (window.App.isLogin)
        {
            return next ()
        }
        else
        {
            return next ('/auth/login')
        }
    }

    /**
     * 检查是否已经是登录状态
     *
     * @param to
     * @param from
     * @param next
     * @returns {*}
     */
    Vue.prototype._checkIfLogin = function (to, from, next)
    {
        if (window.App.isLogin)
        {
            return next ('/')
        }
        else
        {
            return next ()
        }
    }

    /**
     * 设置访问标题
     *
     * @param title
     * @private
     */
    Vue.prototype._setDocumentTitle = function (title)
    {
        document.title = title;
        let ua         = navigator.userAgent;
        if (/\bMicroMessenger\/([\d\.]+)/.test (ua) && /ip(hone|od|ad)/i.test (ua))
        {
            var i           = document.createElement ('iframe');
            i.src           = '/favicon.ico';
            i.style.display = 'none';
            i.onload        = function ()
            {
                setTimeout (function ()
                {
                    i.remove ();
                }, 9);
            };
            document.body.appendChild (i);
        }
    }

    /**
     * table tr 删除
     *
     * @param me
     * @param url
     * @param params
     */
    Vue.prototype.tableItemDelete = function (me, url, params = "?")
    {

        //删除之前先确认
        var callback = function ()
        {

            var $table = me.$vueStore.state.common.table;

            if ($table.selected.length > 0)
            {
                var data = [];

                $table.selected.forEach (function (item)
                {

                    data.push (item.id)
                })

                me.deleteDisabled = true;

                me.$http.delete (url + data.join (',') + params)
                    .then ((response)=>
                    {

                        //刷新数据
                        if (response.data.success)
                        {

                            //删除data里的条目
                            $table.selectedIndex.forEach ((i)=>
                            {
                                me.$vueStore.commit ('tableData', $table.data.splice (i, 1))
                            })

                            //刷新data
                            me.$emit ('reload');
                        }
                    })
                    .catch ()
                    .then (()=>
                    {
                        Vue.nextTick (function ()
                        {
                            me.deleteDisabled = false;
                        })
                    })
            }
        }

        me.$root.$emit ('global-delete-confirm-show', callback)

    }

    /**
     * 深拷贝
     */
    Vue.prototype.cloneObject = function (o, d)
    {
        if (o === null || o === undefined || typeof ( o ) !== 'object')
        {
            return o;
        }

        var deep = !!d;

        var cloned;

        if (o.constructor === Array)
        {
            if (deep === false)
            {
                return o;
            }

            cloned = [];

            for (var i in o)
            {
                cloned.push (this.cloneObject (o[i], deep));
            }

            return cloned;
        }

        cloned = {};

        for (var i in o)
        {
            cloned[i] = deep ? this.cloneObject (o[i], true) : o[i];
        }

        return cloned;
    }

    /**
     *
     * 获取当前时间
     *
     * @param type
     * @returns {string}
     */
    Vue.prototype.currentDateTime = function (type = '')
    {
        var now     = new Date ();
        var year    = now.getFullYear ().toString ();
        var month   = now.getMonth ().toString ();
        var day     = now.getDate ().toString ();
        var hours   = now.getHours ().toString ();
        var minutes = now.getMinutes ().toString ();
        var seconds = now.getSeconds ().toString ();
        switch (type)
        {
            case 'date':
                return year + '-' + month + '-' + day;
            case 'time':
                return hours + ':' + minutes;
            default:
                return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
        }
    }

    /**
     * 对象转字符串
     *
     * @param obj
     * @returns {string}
     */
    Vue.prototype.objectToQuery = function (obj)
    {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty (p))
            {
                str.push (encodeURIComponent (p) + "=" + encodeURIComponent (obj[p]));
            }
        return str.join ("&");
    }

    /**
     *
     * @param {*} query
     */
    Vue.prototype.queryToObject = function(query) {

         var theRequest = new Object();
         if (query.indexOf("?") != -1) {
            const str = query.substr(1);
            const strs = str.split("&");
            for(var i = 0; i < strs.length; i ++) {
               theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1]);
            }
         }
         return theRequest;
      }
}



// WEBPACK FOOTER //
// ./src/plugins/helper/index.js